export const CLEAR_ERRORS = 'CLEAR_ERRORS';

export const USERS_SUPPLIES_ERROR = 'USERS_SUPPLIES_ERROR';
export const USER_BORROWS_ERROR = 'USER_BORROWS_ERROR';
export const WALLETS_ERROR = 'WALLETS_ERROR';
export const NETWORKS_ERROR = 'NETWORKS_ERROR';
export const INFO_ERROR = 'INFO_ERROR';
export const VAULT_ERROR = 'VAULT_ERROR';
export const WITHDRAWAL_ERROR = 'WITHDRAWAL_ERROR';
export const DEPOSIT_ERROR = 'DEPOSIT_ERROR';
export const USER_VAULTS_ERROR = 'USER_VAULTS_ERROR';
export const MARGIN_ACCOUNTS_ERROR = 'MARGIN_ACCOUNTS_ERROR';
export const ORGANIZATION_MEMBERS_ERROR = 'ORGANIZATION_MEMBERS_ERROR';
export const USER_MARGIN_ACCOUNTS_ERROR = 'USER_MARGIN_ACCOUNTS_ERROR';
export const USERS_VAULTS_CONTRACT_NOT_AVAILABLE_ERROR =
    'USERS_VAULTS_CONTRACT_NOT_AVAILABLE_ERROR';
export const USERS_VAULTS_PENDING_REWARDS_ERROR = 'USERS_VAULTS_PENDING_REWARDS_ERROR';
export const USERS_SUPPLIES_BALANCE_ERROR = 'USERS_SUPPLIES_BALANCE_ERROR';
export const USERS_SUPPLIES_PENDING_REWARDS_ERROR = 'USERS_SUPPLIES_PENDING_REWARDS_ERROR';
export const COLLATERAL_AGREEMENT_ERROR = 'COLLATERAL_AGREEMENT_ERROR';
export const COLLATERAL_WALLET_ERROR = 'COLLATERAL_WALLET_ERROR';
export const COLLATERAL_TOKENS_ERROR = 'COLLATERAL_TOKENS_ERROR';
export const COLLATERAL_GENERAL_ERROR = 'COLLATERAL_GENERAL_ERROR';
export const ASSET_PRICES_ERROR = 'ASSET_PRICES_ERROR';
export const ASSET_PRICE_ERROR = 'ASSET_PRICE_ERROR';
export const ASSET_PRICE_GENERAL_ERROR = 'ASSET_PRICE_GENERAL_ERROR';
export const AGREEMENTS_ERROR = 'AGREEMENTS_ERROR';
export const TOKENS_ERROR = 'TOKENS_ERROR';
export const AGREEMENT_ROLE_ERROR = 'AGREEMENT_ROLE_ERROR';
export const TOKEN_PRICE_ERROR = 'TOKEN_PRICE_ERROR';
export const AGREEMENT_CONTRACT_ERROR = 'AGREEMENT_CONTRACT_ERROR';
export const AGREEMENT_LEVERAGE_ERROR = 'AGREEMENT_LEVERAGE_ERROR';
export const REMOVE_AGREEMENT_CONTRACT_ERROR = 'REMOVE_AGREEMENT_CONTRACT_ERROR';
export const AGREEMENT_GENERAL_ERROR = 'AGREEMENT_GENERAL_ERROR';
export const WALLET_BALANCE_ERROR = 'WALLET_BALANCE_ERROR';
export const TOKEN_BALANCE_ERROR = 'TOKEN_BALANCE_ERROR';
export const AGREEMENT_DETAILS_ERROR = 'AGREEMENT_DETAILS_ERROR';
export const AGREEMENT_FETCH_ERROR = 'AGREEMENT_FETCH_ERROR';
